import { useKnockFeed, useNotificationStore } from '@knocklabs/react';

/**
 * Unread count from the Knock feed store. Must run under KnockFeedProvider.
 */
export function useKnockUnreadCount(): number {
  const { feedClient } = useKnockFeed();
  return useNotificationStore(feedClient, (state) => state.metadata.unread_count ?? 0);
}
